import * as CookieConsent from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";

// Keys must be Segment's integration names, which differ from the UI labels.
const SEGMENT_INTEGRATIONS = {
  marketing: ["Actions Google Analytic 4", "Mixpanel", "Drip", "Visual Tagger"],
  advertising: ["Facebook Pixel"],
};

// analytics.js keeps its identity under these keys, in cookies and localStorage.
const SEGMENT_STORAGE = /^ajs_/;

initConsentManager();

function initConsentManager() {
  // __CONSENT_MANAGER__ is initialized in _analytics_body.html.erb
  const config = window.__CONSENT_MANAGER__ || {};

  if (!config.key) {
    console.error("No Segment write key for consent manager found.");
    return;
  }

  CookieConsent.run({
    categories: {
      essential: { enabled: true, readOnly: true },
      // Withdrawing a category also erases what its device-mode destinations stored.
      marketing: { autoClear: { cookies: [{ name: /^_?drip/i }] } },
      advertising: { autoClear: { cookies: [{ name: /^_fb[pc]$/ }] } },
    },
    language: {
      default: config.locale,
      translations: { [config.locale]: config.translations },
    },
    onConsent: () => loadSegment(config.key),
    // analytics.js cannot drop an integration once loaded, so reload instead.
    onChange: () => {
      if (!consentedToSomething()) forgetSegmentIdentity();
      window.location.reload();
    },
  });
}

function loadSegment(writeKey) {
  if (!window.analytics) return;

  // Even with every destination off, Segment itself would still collect the
  // page call, bill it and set an anonymous id, so do not load at all.
  if (!consentedToSomething()) return;

  window.analytics.load(writeKey, { integrations: allowedIntegrations() });
}

function consentedToSomething() {
  return Object.keys(SEGMENT_INTEGRATIONS).some((category) =>
    CookieConsent.acceptedCategory(category)
  );
}

function allowedIntegrations() {
  // "All" is Segment's (case-sensitive) wildcard: a destination not listed in
  // SEGMENT_INTEGRATIONS receives nothing, even if it is enabled in Segment.
  const integrations = { All: false, "Segment.io": true };

  Object.entries(SEGMENT_INTEGRATIONS).forEach(([category, names]) => {
    const accepted = CookieConsent.acceptedCategory(category);
    names.forEach((name) => { integrations[name] = accepted; });
  });

  return integrations;
}

function forgetSegmentIdentity() {
  CookieConsent.eraseCookies([SEGMENT_STORAGE]);
  try {
    Object.keys(localStorage)
      .filter((key) => SEGMENT_STORAGE.test(key))
      .forEach((key) => localStorage.removeItem(key));
  } catch (_) {
    // Storage is disabled: nothing was stored, nothing to forget.
  }
}

$.onmount("[data-behavior~=consent-activator]", function() {
  $(this).on("click", function() {
    CookieConsent.showPreferences();
  });
});
